import { FormLabel, FormControl, Select, Option, FormHelperText } from "@mui/joy";
import { useFormContext, useController } from "react-hook-form";

type Props = {
  name: string;
  label: string;
  options: { name: string; value: string }[];
  multiple?: boolean;
  disabled?: boolean;
};

export default function SelectInput({ name, label, options, multiple, disabled }: Props) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    name,
    control,
  });

  return (
    <FormControl error={Boolean(fieldState.error)}>
      <FormLabel>{label}</FormLabel>
      <Select
        name={name}
        value={field.value ?? ""}
        onChange={(_e, value) => field.onChange(value)}
        multiple={multiple}
        disabled={disabled}
      >
        {options.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.name}
          </Option>
        ))}
      </Select>
      {fieldState.error?.message ? (
        <FormHelperText>{fieldState.error?.message}</FormHelperText>
      ) : null}
    </FormControl>
  );
}
